import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";
import { infoFunction } from "../../../../Components/Alert/Alert";

// get user group
export const getUserGroup = createAsyncThunk("userGroup/getUserGroup", async (params, { rejectWithValue }) => {
  const { rowsPerPage, search, sortOrder, pageNo } = params;
  try {
    const { data } = await API.getUserGroup({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get all user groups
export const getAllUserGroup = createAsyncThunk("userGroup/getAllUserGroup", async (_, { rejectWithValue }) => {
  try {
    const { data } = await API.getAllUserGroup();
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get previous
export const getPrevious = createAsyncThunk("userGroup/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("userGroup/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getPageUserGroup = createAsyncThunk("userGroup/getPageUserGroup", async (params, { rejectWithValue }) => {
  const { number, rowsPerPage, search } = params;
  try {
    const { data } = await API.getPageUserGroup({ number, rowsPerPage: rowsPerPage, search });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// create user group
export const createUserGroup = createAsyncThunk("userGroup/createUserGroup", async (data, { rejectWithValue }) => {
  const { name, isActive, permissions } = data;
  try {
    const body = JSON.stringify({ name, isActive, permissions });
    const { data } = await API.createUserGroup(body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});

// update user group
export const updateUserGroup = createAsyncThunk(
  "userGroup/updateUserGroup",
  async (data, { rejectWithValue, dispatch }) => {
    const { id, values } = data;
    const { name, isActive, permissions, remarks } = values;
    try {
      const body = JSON.stringify({ name, isActive, permissions, remarks });
      const { data } = await API.updateUserGroup(id, body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

// delete user group
export const deleteUserGroup = createAsyncThunk(
  "userGroup/deleteUserGroup",
  async (id, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await API.deleteUserGroup(id);
      dispatch(getUserGroup(10));
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get all permission
export const getAllPermission = createAsyncThunk("userGroup/getAllPermission", async (_, { rejectWithValue }) => {
  try {
    const { data } = await API.getAllPermission();
    if (data.totalCount === 0) {
      infoFunction("No permissions available");
    }
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// handle search
export const handleSearch = createAsyncThunk("userGroup/handleSearch", async (data, { rejectWithValue }) => {
  const { search, rowsPerPage } = data;
  try {
    const { data } = await API.handleSearch(search, rowsPerPage);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// specific user permissions
export const getSpecificUserPermissions = createAsyncThunk(
  "userGroup/getSpecificUserPermissions",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await API.getSpecificPermissions(id);
      if (data.totalCount === 0) {
        infoFunction("No permissions available.");
      }
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
